<template>
  <div class="clientSelector">
    <div v-if="isLoggedIn && clients.length > 1">
      <kendo-dropdownlist
        :filter="'contains'"
        :dataSource="clients"
        data-text-field="name"
        data-value-field="clientId"
        :value="selectedClientId"
        @change="this.selectedClientChange"
      ></kendo-dropdownlist>
    </div>
    <div class="imageWrapper"><img class="logo" :src="logoUrl" /></div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  methods: {
    async selectedClientChange(e) {
      let selectedClientId = +e.sender.value()
      await this.$store.dispatch('authentication/setSelectedClientId', {selectedClientId})
      const selectedPeriod = -1
      this.$store.dispatch('app/selectPeriod', {selectedPeriod})
      await this.$store.dispatch('app/setClientConfiguration', {selectedClientId})

      const marketItem = this.userClientMarkets.find(x => x.marketId == this.currentMarketId)
      if (!marketItem) {
        const marketId = -1
        this.$store.dispatch('app/setMenuMarket', {marketId})
        this.$router.push('/')
      } else {
        const {path, hash} = this.$route
        this.$router.push({path, hash: hash ? '' : 'c'})
      }
    },
  },
  computed: {
    ...mapGetters({
      isLoggedIn: 'authentication/isLoggedIn',
      clients: 'authentication/clients',
      defaultClientId: 'authentication/defaultClientId',
      selectedClientId: 'authentication/selectedClientId',
      currentMarketId: 'app/marketId',
      userClientMarkets: 'authentication/userClientMarkets',
    }),
    logoUrl() {
      return `/api/config/Client/GetLogo?clientId=${this.selectedClientId}`
    },
  },
}
</script>

<style scoped>
img.logo {
  max-height: 35px;
  max-width: 100px;
  vertical-align: middle;
}
.clientSelector {
  display: inline;
}
.clientSelector > div {
  display: inline-block;
  text-align: center;
  margin: 0.5em 0;
}

.imageWrapper {
  display: contents;
  height: 100%;
  vertical-align: middle;
}
</style>
